/** The build this page comes from; set by vite.config.ts at build time. */
export type Build = { version: string; commit: string; ref: string; date: string };

declare const __BUILD__: Build;

export const BUILD: Build = __BUILD__;
